/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcribe_After_Import_TextInputs */



/**
* | output |
* | --- |
* | "Would you like to automatically transcribe and generate subtitles for your media?" |
*
* @param {Transcribe_After_Import_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcribe_after_import_text = /** @type {((inputs?: Transcribe_After_Import_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcribe_After_Import_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
	return /** @type {LocalizedString} */ ("Would you like to automatically transcribe and generate subtitles for your media?")
});